import styled from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

import { XSMALL_BREAKPOINT } from '../../../../style'
interface ThumbnailProps {
  background?: string
  product?: boolean
  template?: boolean
}
export const Container = styled.div`
  border-radius: 20px;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 2px 48px rgba(0, 0, 0, 0.1);
  position: relative;
`
export const Footer = styled.div`
  background: ${colors.radagast};
  color: ${colors.black1};
  font-size: 0.875rem;
  line-height: 1.5rem;
  height: 2.5rem;
  padding: 0 1.5rem;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const FooterFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  > div {
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1rem;
    color: ${colors.black1};
    visibility: hidden;
  }

  strong {
    font-weight: 900;
    font-size: 1rem;
    line-height: 1.625rem;
    margin-left: 0.25rem;
  }
`
export const OrderLink = styled.a`
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.125rem;
  color: ${colors.adaptBlue};
  display: flex;
  justify-content: space-between;
  align-items: center;

  > img {
    margin-left: 4px;
  }

  &:hover {
    color: ${colors.adaptBlue};
  }
`
export const ProductLink = styled.span`
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.125rem;
  color: ${colors.adaptBlue};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 0.75rem;
  right: 0.75rem;
  cursor: pointer;

  > img {
    margin-left: 4px;
  }

  &:hover {
    color: ${colors.adaptBlue};
  }
`
export const Content = styled.div<{ product?: boolean }>`
  border-radius: 12px;
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  overflow: hidden;
  padding: 0.75rem;
  height: 100%;

  > div:first-child {
    z-index: 19;
    flex: 1;
    display: flex;
    flex-direction: column;
  }
`
export const Thumbnail = styled.div<ThumbnailProps>`
  background: ${({ background }) => (background ? `url(${background})` : colors.gandalf)};
  position: relative;
  border-radius: 0.75rem;
  /* stylelint-disable */
  padding-bottom: ${({ product, template }) => (product || template ? `54%` : `63%`)};
  /* stylelint-enable */
  background-size: cover;
  background-position: center;
  overflow: hidden;
  margin-bottom: ${({ product, template }) => (product || template ? `0.75rem` : `0.5rem`)};

  video {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  img {
    z-index: 1;
  }
`
export const Price = styled.div`
  position: absolute;
  font-size: 1rem;
  color: white;
  font-weight: 900;
  top: 0.5rem;
  left: 0.5rem;
  z-index: 1;
  background: rgba(7, 7, 7, 0.25);
  backdrop-filter: blur(0.75rem);
  border-radius: 0.5rem;
  height: 2rem;
  padding: 0 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1.625rem;

  span {
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.375rem;
  }
`
export const ProjectStats = styled.div`
  display: inline-flex;
  padding-top: 1rem;
  padding-bottom: 0.125rem;
`
export const Stat = styled.div`
  color: ${colors.black1};
  margin-right: 1rem;
  font-weight: 700;
  font-size: 0.625rem;
  line-height: 1.125rem;
  display: flex;
  justify-content: center;
  align-items: center;

  strong {
    font-size: 0.75rem;
    font-weight: 900;
    display: block;
    line-height: 1.625rem;
  }

  img {
    width: 0.75rem;
    margin-right: 0.375rem;
  }
`
export const ProjectTitle = styled.div`
  color: ${colors.black1};
  font-weight: 900;
  line-height: 1.625rem;
  font-size: 1rem;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    text-derocation: underline;
  }

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    font-size: 1.25rem;
  }
`
export const BottomFlex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  order: -1;
`
export const DueDate = styled.div`
  color: ${colors.black1};
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;

  strong {
    font-weight: 700;
  }
`
export const ViewLink = styled.div`
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 1.125rem;
  color: ${colors.adaptBlue};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  picture {
    line-height: 1px;
    height: 11px;
  }

  img {
    margin-left: 0.3rem;
    vertical-align: baseline;
  }
`
export const ProjectState = styled.div`
  font-weight: 700;
  font-size: 0.625rem;
  line-height: 0.875rem;
  text-transform: uppercase;
  color: white;
  position: absolute;
  bottom: 0.875rem;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 1;
`
export const PlayButton = styled.div`
  background: url(https://res.cloudinary.com/ninety-seconds/image/upload/v1582007941/-icons-browse-order-deliver/-order/button-play.svg)
    no-repeat center;
  width: 3rem;
  height: 3rem;
  position: absolute;
  border-radius: 50%;
  overflow: hidden;
  background-size: contain;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  cursor: pointer;
`
export const Tags = styled.div`
  display: flex;

  &.template {
    justify-content: space-between;
  }
`
export const Tag = styled.div`
  color: ${colors.black1};
  height: 2rem;
  font-weight: 700;
  font-size: 0.625rem;
  line-height: 0.75rem;
  text-transform: uppercase;
  margin-right: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0.75rem;
  border: 1px solid ${colors.gandalf};
  border-radius: 1.25rem;

  &.completed {
    background: #36c17e;
    color: white;
    border: 1px solid #36c17e;
  }

  &.active {
    background: ${colors.adaptBlue};
    color: white;
    border: 1px solid ${colors.adaptBlue};

    picture {
      margin-right: 0.5rem;
    }
  }
`
export const PopupWrapper = styled.div`
  position: absolute;
  width: 2rem;
  height: 2rem;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: rgba(7, 7, 7, 0.75);
  backdrop-filter: blur(0.75rem);
  border-radius: 50%;
  top: 1.25rem;
  right: 1.25rem;
`
export const Dots = styled.div`
  width: 0.25rem;
  height: 0.25rem;
  background: ${colors.white};
  border-radius: 50%;
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    width: 0.25rem;
    height: 0.25rem;
    background: ${colors.white};
    border-radius: 50%;
    right: 0.438rem;
  }
  &::before {
    content: '';
    position: absolute;
    width: 0.25rem;
    height: 0.25rem;
    background: ${colors.white};
    border-radius: 50%;
    left: 0.438rem;
  }
`
export const PopupMenu = styled.div`
  background: ${colors.black1};
  border-radius: 0.5rem;
  z-index: 2;
  position: absolute;
  right: 1.38rem;
  top: 3.5rem;
  overflow: hidden;
  min-width: 6.875rem;
  width: max-content;
`
export const Item = styled.div<{ icon: string }>`
  color: ${colors.white};
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.125rem;
  height: 42px;
  display: flex;
  border-bottom: 1px solid ${colors.black3};
  background: url(${({ icon }) => icon}) no-repeat left;
  padding: 0 1rem 0 2.75rem;
  justify-content: left;
  background-size: 16px 16px;
  background-position: 16px;
  align-items: center;
  cursor: pointer;

  &:last-child {
    border: none;
  }
`
export const ProductInnerWrapper = styled.div`
  z-index: 1;
  margin-bottom: 0.75rem;
`
export const ProductTitle = styled.h3`
  font-weight: 900;
  font-size: 1rem;
  line-height: 1.625rem;
  color: ${colors.black1};
  margin: 0;
`
export const ProductDescription = styled.p`
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.5rem;
  color: ${colors.black1};
`
export const CardLink = styled.a`
  display: inline-block;
  height: 100%;

  &:focus {
    text-decoration: none;
  }
`
export const Loading = styled.div`
  position: fixed;
  z-index: 99;
  color: ${colors.black1};
  background: white;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    display: block;
    margin: 0 auto;
  }
`
export const BrandName = styled.div`
  font-weight: 400;
  font-size: 0.563rem;
  line-height: 0.875rem;
  color: ${colors.black1};
  text-transform: uppercase;

  strong {
    font-weight: 700;
  }
`
export const LocationTag = styled.div`
  height: 1.875rem;
  border: 1px solid ${colors.gandalf};
  border-radius: 6.25rem;
  padding: 0 0.5rem 0 1.875rem;
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: ${colors.black1};
  font-weight: 600;
  font-size: 0.625rem;
  line-height: 1.125rem;
  text-transform: uppercase;
  margin-top: 0.375rem;

  &::after {
    content: '';
    height: 1.875rem;
    width: 1rem;
    background: url(https://res.cloudinary.com/ninety-seconds/image/upload/v1618413216/-design-system/icon-locate.svg)
      center no-repeat;
    background-size: 1rem 1rem;
    position: absolute;
    left: 0.5rem;
    top: 0;
  }
`
export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background: ${colors.gandalf};
  margin: 0.75rem 0;
`
export const Transparent = styled.div`
  border-radius: 0.5rem;
  background: rgba(7, 7, 7, 0.25);
  backdrop-filter: blur(12px);
  color: white;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.375rem;
  height: 2rem;
  padding: 0 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.25rem;

  img {
    max-width: 15px;
  }
`
export const TransparentWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
`
export const HiddenLabel = styled.div`
  align-items: center;
  backdrop-filter: blur(12px);
  background: rgba(7, 7, 7, 0.25);
  border-radius: 8px;
  display: inline-flex;
  gap: 4px;
  height: var(--32, 32px);
  padding: 3px 8px;

  bottom: 0.5rem;
  color: white;
  justify-content: center;
  left: 0.5rem;
  position: absolute;
  z-index: 1;

  img {
    align-items: center;
    display: flex;
    height: 20px;
    justify-content: center;
    padding: 2.708px 1.042px;
    width: 20px;
  }

  span {
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
  }
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/BrandOrderCard/BrandOrderCard.style.tsx